import { Close20 } from '@carbon/icons-react';
import React, { FC } from 'react';

export interface TagProps {
  text: string;
  onIconCloseClick?: () => void;
  color: 'primary' | 'white';
}
const Tag: FC<TagProps> = (props: TagProps) => {
  const { text, color, onIconCloseClick } = props;
  const colors = {
    primary:
      'bg-purple80 hover:bg-purple90 text-white monochrome:bg-grey80 monochrome:hover:bg-grey90',
    white:
      'bg-white text-purple80 hover:bg-grey10 monochrome:bg-white monochrome:text-grey90 hover:bg-grey10',
  };
  const colorClasses = colors[color];
  return (
    <>
      <div
        className={`inline-flex items-center rounded-circle font-regular text-p2 ${colorClasses} py-5px pr-10px pl-20px`}
      >
        <span className="filter-color pr-20px">{text}</span>
        {onIconCloseClick && (
          <button onClick={onIconCloseClick} type="button">
            <Close20 />
          </button>
        )}
      </div>
    </>
  );
};

export default Tag;
